import ChatBotPage from './views/chatbot.page';

export default {
  views: { ChatBotPage },
};
